import "../../../assets/css/tabs/addStaffManually.css"
import close from "../../../assets/images/close.svg"

import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useAuth } from "../../../context/auth-user";
import useStaffList from "./hooks/useStaffList";

export default function AddStaffManually(props) {
    const { showModal, onHide, supplier, entitySelected } = props;

    const {
            data: staffList = [],
            createStaffHandler
        } = useStaffList({
            supplier
        });

    const { user } = useAuth()
    const darkMode = user?.selectedProfile?.darkLightMode || false

    const { register, formState: { errors }, handleSubmit, setError, reset } = useForm({
        defaultValues: {
            name: "",
            imss: "",
            curp: "",
            active: true,
            payrollReceipts: []
        }
    });

    const onSubmit = async (data) => {
        const memberExists = staffList.some(member => member.imss?.toLocaleUpperCase() === data.imss?.toLocaleUpperCase())

        if (memberExists) {
            setError("imss", {
                type: "manual",
                message: "A member with this NSS already exists."
            });

            return;
        }

        const result = await createStaffHandler({
            supplierId: supplier._id,
            entityId: entitySelected._id,
            staffData: data
        })

        if (!result) return

        reset()

        onHide()
    }

    return (
            <Modal
                className={`addStaffModal addStaffManuallyModal ${darkMode ? "darkMode" : ""}`}
                show={showModal}
                onHide={onHide}
                size="lg"
                centered>
                <Modal.Body className="addStaffManuallyBody">
                    <img className="closeModal" src={close} onClick={() => onHide()} alt="Prodensa Supplier" />
    
                    <h4 className="title">Add member</h4>
                    <p className="description">
                        Add a new member by filling out the form below
                    </p>

                    <form className="addStaffForm" onSubmit={handleSubmit(onSubmit)}>
                        <div className="inputContainer">
                            <span className="label">Name</span>
                            <input placeholder="Enter staff name" type="text" {...register("name", { required: "Name is required." })} aria-invalid={errors.name ? "true" : "false"} />
                        </div>

                        <div className="inputContainer">
                            <span className="label">NSS</span>
                            <input placeholder="Enter NSS" type="text" {...register("imss", { required: "NSS is required.", minLength: { value: 11, message: "NSS must be 11 characters long." } })} aria-invalid={errors.imss ? "true" : "false"} />
                        </div>

                        <div className="inputContainer">
                            <span className="label">RFC</span>
                            <input placeholder="Enter RFC" type="text" {...register("curp", { required: "RFC is required." })} aria-invalid={errors.curp ? "true" : "false"} />
                        </div>

                        {errors.name && <span className="errorMessage">{errors.name.message}</span>}
                        {errors.imss && <span className="errorMessage">{errors.imss.message}</span>}
                        {errors.curp && <span className="errorMessage">{errors.curp.message}</span>}

                        <button className="btnBgBlueTextGradient" type="submit">Add Member</button>
                    </form>
                </Modal.Body>
            </Modal>
        )
}
